import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fingerPrintPromise = FingerprintJS.load();

const fingerprint = async (): Promise<string> => {
    const fingerPrint = await fingerPrintPromise;
    const result = await fingerPrint.get();
    return result.visitorId;
};

export default fingerprint;
